import React from 'react';
import './LanguageSwitcher.css';
import { LANGUAGES, useTranslation } from '../i18n';

// Drapeau de chaque langue (images de public/images/atlas_flags)
const FLAGS = { fr: 'fr-flag.jpg', en: 'uk-flag.jpg' };

// Choix de la langue du site : un drapeau par langue, la langue active est mise en avant
function LanguageSwitcher() {
    const { t, lang, setLang } = useTranslation();

    return (
        <div className="language_switcher" role="group" aria-label={t('lang.label')}>
            {
                LANGUAGES.map((item) => (
                    <button
                        key={item}
                        type="button"
                        className={"language_switcher_btn" + (item === lang ? " active" : "")}
                        onClick={() => setLang(item)}
                        aria-pressed={item === lang}
                        title={t('lang.' + item)}
                        lang={item}
                    >
                        <img src={process.env.PUBLIC_URL + "/images/atlas_flags/" + FLAGS[item]} alt={t('lang.' + item)} />
                    </button>
                ))
            }
        </div>
    );
}

export default LanguageSwitcher;
